export default [
  {
    name: 'users',
    path: '/users',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Usuários',
      icon: 'dvr',
      label: 'Usuários'
    }
  }
]
